import { useEffect, useRef } from 'react';

interface CodeInputProps {
  isLoading: boolean;
  onChange: (v: string) => void;
  onSubmit: () => void;
  value: string;
}

function CodeInput({ isLoading, onChange, onSubmit, value }: CodeInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <label
        className="mb-1 block text-sm font-medium"
        htmlFor="mfa-setup-code"
      >
        Verification code
      </label>
      <input
        id="mfa-setup-code"
        autoComplete="one-time-code"
        className="w-full rounded-md border border-read-only-bg px-3 py-2.5 text-center font-mono text-base tracking-widest outline-none focus:border-sr-text-brand focus:ring-1 focus:ring-sr-text-brand"
        inputMode="numeric"
        placeholder="Enter 6-digit code"
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => {
          const val = e.target.value.replace(/\D/g, '').slice(0, 6);

          onChange(val);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && value.trim().length === 6 && !isLoading) {
            onSubmit();
          }
        }}
      />
    </>
  );
}

export default CodeInput;
